import { useLocation } from "react-router-dom";

import { EMBEDDED_RULE_PARAM } from "../surface/deriveEmbeddedPaths";
import { useEmbeddedAgenticLogicView } from "../surface/useEmbeddedAgenticLogicSurface";
import { useSurfaceNavigate } from "../surface/useSurfaceNavigate";

export { NEW_RULE_PARAM_VALUE } from "../surface/ruleViewParams";

/**
 * Whether a rule builder has taken over the host's content. Hosts read this to
 * hide their own content — hide, never unmount: an upsell's settings own a
 * storefront preview iframe, and unmounting it reloads the storefront and
 * loses the cart the merchant was previewing against.
 */
export const useIsAgenticLogicTakeoverActive = (): boolean =>
  useEmbeddedAgenticLogicView().kind !== "list";

/**
 * Opens the takeover — on the creation view with `NEW_RULE_PARAM_VALUE`, or on
 * a rule's workspace with its id. It is a navigation on the host's own URL, so
 * the host stays mounted with everything it holds unsaved, and the browser's
 * back button leaves the builder.
 *
 * Kept apart from the takeover component itself so a picker can offer the
 * affordance without importing the chat rail behind it.
 */
export const useOpenAgenticLogicTakeover = () => {
  const navigate = useSurfaceNavigate();
  const { pathname, search } = useLocation();
  return (target: string) => {
    const params = new URLSearchParams(search);
    params.set(EMBEDDED_RULE_PARAM, target);
    navigate(`${pathname}?${params.toString()}`);
  };
};
